import { Component, Inject } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-submit-confirm-dialog',
	standalone: true,
	imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule, MatDialogModule],
	templateUrl: './submit-confirm-dialog.component.html',
	styleUrls: ['./submit-confirm-dialog.component.scss']
})
export class SubmitConfirmDialogComponent {
	isLoading = false;

	constructor(
		public dialogRef: MatDialogRef<SubmitConfirmDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	closeDialog() {
		this.dialogRef.close(false);
	}

	submitQuiz() {
		this.dialogRef.close({ action: 'submit' });
	}
}